module.exports = __webpack_public_path__ + "img/master-card.0bbd433e.svg";